export { default as withOnlyLoggedIn } from './with-only-logged-in';
